import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronDown, MoreVertical, Star } from "lucide-react";
import { MdFollowTheSigns } from "react-icons/md";
export default function ReportsPage() {
  const navigate = useNavigate();
  const {portalName} = useParams();
  const [sections, setSections] = useState([
    {
      title: "Followup",
      count: 1,
      open: true,
      icon: <MdFollowTheSigns/>,
      reports: [
        {
          name: "Daily Followup",
          desc: "User daily followup report",
          lastVisited: "2 hours ago",
          createdBy: "Admin",
          route: `/${portalName}/reports/daily-followup`,
        },
        
      ],
    },
    {
      title: "Stage Client Report",
      count: 1,
      open: true,
      icon: <MdFollowTheSigns/>,
      reports: [
        {
          name: "Stage Client Report",
          desc: "Client Stage report",
          lastVisited: "2 hours ago",
          createdBy: "Admin",
          route: `/${portalName}/reports/client-stage`,
        },
        
      ],
    },
    // {
    //   title: "Client Map View Report",
    //   count: 1,
    //   open: true,
    //   icon: <MdFollowTheSigns/>,
    //   reports: [
    //     {
    //       name: "Client Map View",
    //       desc: "Client Map View Report",
    //       lastVisited: "2 hours ago",
    //       createdBy: "Admin",
    //       route: `/${portalName}/reports/client-map`,
    //     },
        
    //   ],
    // },
    {
      title: "Client Onboarding Calendar",
      count: 1,
      open: true,
      icon: <MdFollowTheSigns/>,
      reports: [
        {
          name: "Onboarding Client Calendar View",
          desc: "Client Calendar View",
          lastVisited: "2 hours ago",
          createdBy: "Admin",
          route: `/${portalName}/reports/onboarding-calendar`,
        },
        
      ],
    },
    // {
    //   title: "MIS Report",
    //   count: 1,
    //   open: true,
    //   icon: <MdFollowTheSigns/>,
    //   reports: [
    //     {
    //       name: "MIS Report",
    //       desc: "Management Information System",
    //       lastVisited: "2 hours ago",
    //       createdBy: "Admin",
    //       route: `/${portalName}/reports/mis-report`,
    //     },
        
    //   ],
    // },
    // {
    //   title: "Customer Management",
    //   count: 0,
    //   open: false,
    //   reports: [],
    // },
    // {
    //   title: "Sales & Orders",
    //   count: 0,
    //   open: false,
    //   reports: [],
    // },
  ]);

  const toggleSection = (index) => {
    const updated = [...sections];
    updated[index].open = !updated[index].open;
    setSections(updated);
  };

return (
  <div className="min-h-screen p-4">

    {/* 🔍 TOP BAR */}
    <div className="flex flex-col md:flex-row justify-between items-center gap-3 mb-5">
      <input
        type="text"
        placeholder="Search reports by name, module or author..."
        className="w-full md:w-[65%] px-4 py-2.5 rounded-xl border border-gray-200 text-sm outline-none bg-white"
      />

      <div className="flex gap-2 w-full md:w-auto">
        <button className="flex items-center gap-2 border px-4 py-2.5 rounded-xl text-sm bg-white text-gray-600">
          📅 Last 30 Days
        </button>
        <button className="flex items-center gap-2 border px-4 py-2.5 rounded-xl text-sm bg-white text-gray-600">
          ⚙ Filters
        </button>
      </div>
    </div>

    {/* 📊 SECTIONS */}
    {sections.map((section, index) => (
      <div
        key={index}
        className="bg-white rounded-xl mb-[10px] shadow-[0_2px_8px_rgba(0,0,0,0.04)] overflow-hidden"
      >
        {/* HEADER */}
        <div
          onClick={() => toggleSection(index)}
          className={`flex justify-between items-center px-5 py-4 cursor-pointer ${
            section.open ? "bg-[#DE2A1B1A]" : "bg-white"
          }`}
        >
          <div className="flex items-center gap-3">

            {/* LEFT ICON */}
            <div className="text-red-500 text-lg">{section.icon}</div>

            <p className="text-[14px] font-medium text-gray-700">
              {section.title}
            </p>

            <span className="text-[11px] bg-white text-red-500 px-2 py-0.5 rounded">
              {section.count} Reports
            </span>
          </div>

          <ChevronDown
            size={18}
            className={`transition ${
              section.open ? "rotate-180 text-red-500" : "text-gray-400"
            }`}
          />
        </div>

        {/* TABLE */}
        {section.open && section.reports.length > 0 && (
        <div className="pb-3 mt-[1px]">

            {/* HEADER ROW (MERGED STYLE) */}
            <div className="grid grid-cols-2 md:grid-cols-4 text-[13px] text-black px-5 py-3 bg-[#DE2A1B1A]">
            <div>Report Name</div>
            <div className="hidden md:block">Last Visited</div>
            <div className="hidden md:block">Created By</div>
            <div className="text-right pr-2">Actions</div>
            </div>

            {/* ROWS */}
            {section.reports.map((rep, i) => (
            <div
                key={i}
                onClick={() => navigate(rep.route)}
                className="grid grid-cols-2 md:grid-cols-4 items-center px-5 py-3 bg-white border-b last:border-none cursor-pointer hover:bg-gray-50"
            >
                {/* NAME */}
                <div className="flex items-start gap-3">
                <Star size={16} className="text-red-500 mt-[2px]" />

                <div className="space-y-2">
                    <p className="text-red-500 text-[14px] font-medium leading-4">
                    {rep.name}
                    </p>
                    <p className="text-[12px] text-gray-400">
                    {rep.desc}
                    </p>
                </div>
                </div>

                {/* LAST VISITED */}
                <div className="hidden md:block text-[13px] text-gray-600">
                {rep.lastVisited}
                </div>

                {/* CREATED BY */}
                <div className="hidden md:flex items-center gap-2">
                <div className="w-7 h-7 bg-gray-300 rounded-full" />
                <span className="text-[13px] text-gray-700">
                    {rep.createdBy}
                </span>
                </div>

                {/* ACTION */}
                <div className="flex justify-end pr-2">
                <MoreVertical size={16} className="text-gray-400" />
                </div>
            </div>
            ))}
        </div>
        )}
      </div>
    ))}
  </div>
);
}